/**
 * Dekodiert sichtbares &amp; / &#38; in Textknoten (Import-/Metafeld-Doppel-Escape).
 * Korrektes HTML-&amp; landet im Textknoten bereits als "&" und bleibt unverändert.
 */
(function () {
  var ENTITY_RE = /&(?:amp|AMP|#38|#x26|#X26);/g;

  function decodeTextNodes(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      decodeNode(root);
      return;
    }
    if (root.nodeType !== 1) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) {
      var value = walker.currentNode.nodeValue;
      if (value && ENTITY_RE.test(value)) nodes.push(walker.currentNode);
      ENTITY_RE.lastIndex = 0;
    }
    nodes.forEach(decodeNode);
  }

  function decodeNode(node) {
    var next = node.nodeValue;
    for (var i = 0; i < 4; i += 1) {
      var updated = next.replace(/&(?:amp|AMP|#38|#x26|#X26);/g, '&');
      if (updated === next) break;
      next = updated;
    }
    if (next !== node.nodeValue) node.nodeValue = next;
  }

  function decodeAll(root) {
    decodeTextNodes(root || document.body);
  }

  window.coveraxDecodeVisibleEntities = decodeAll;

  function boot() {
    decodeAll(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    decodeAll(event && event.target ? event.target : document.body);
  });

  if (typeof MutationObserver === 'function') {
    var scheduled = [];
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 || node.nodeType === 3) scheduled.push(node);
        });
      });
      if (!scheduled.length) return;
      var batch = scheduled;
      scheduled = [];
      requestAnimationFrame(function () {
        batch.forEach(decodeAll);
      });
    });
    var start = function () {
      if (!document.body) return;
      observer.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  }
})();
